import { IconButton, Tooltip } from "@mui/material";
import { CgAdd } from "react-icons/cg";
import { FaHandHoldingUsd, FaInfoCircle, FaRegEdit, FaUserShield } from "react-icons/fa";
import { MdAddBox, MdAttachMoney } from "react-icons/md";
import { FaList } from "react-icons/fa";
import { GrValidate } from "react-icons/gr";
import { FaMoneyBill1 } from "react-icons/fa6";
import { FaExchangeAlt } from "react-icons/fa";
import { RiVerifiedBadgeLine } from "react-icons/ri";
import { FaSchool } from "react-icons/fa";
import { CiBoxList, CiDiscount1 } from "react-icons/ci";
import { FaRegListAlt } from "react-icons/fa";
import { MdAssessment } from "react-icons/md";
import { FaCalendarAlt } from "react-icons/fa";
import { FaChartBar } from "react-icons/fa";
import { FaUpload } from "react-icons/fa";

interface Props {
  openModal: () => void;
  type?: string;
  disabled?: string;
}

// Set semántico de color: cada acción usa uno de estos roles en vez de un
// tono de Tailwind suelto, para que el significado (primario/éxito/aviso/
// secundario) sea consistente en todos los módulos.
const COLOR = {
  primary: "bg-blue-cole hover:bg-blue-cole-deep",
  success: "bg-emerald-600 hover:bg-emerald-700",
  warning: "bg-amber-500 hover:bg-amber-600",
  accent: "bg-orange-500 hover:bg-orange-600",
  secondary: "bg-violet-600 hover:bg-violet-700",
  disabled: "bg-gray-400 cursor-not-allowed",
};

const BASE_ICON_BTN = "p-2 text-white font-semibold rounded-lg transition-colors";
const BASE_LABEL_BTN = "p-2 text-white text-sm rounded-lg flex items-center gap-2 transition-colors";

export const ButtonModuleGlobal = ({ openModal, type, disabled }: Props) => {
  if (type == "add") {
    return (
      <button
        onClick={openModal}
        disabled={disabled == "Todos" ? true : false}
        className={`${BASE_LABEL_BTN} ${disabled && disabled === "Todos" ? COLOR.disabled : COLOR.success}`}
      >
        <CgAdd size={20} /> Ingreso Nuevo
      </button>
    );
  }

  if (type == "edit") {
    return (
      <Tooltip title="Editar" arrow>
        <button onClick={openModal} className={`${BASE_ICON_BTN} ${COLOR.warning}`}>
          <FaRegEdit size={18} />
        </button>
      </Tooltip>
    );
  }

  if (type == "report") {
    return (
      <Tooltip title="Generar Reporte" arrow>
        <button
          disabled={disabled == "Todos" ? true : false}
          onClick={openModal}
          className={`${BASE_ICON_BTN} ${disabled && disabled === "Todos" ? COLOR.disabled : COLOR.warning}`}
        >
          <MdAssessment size={18} />
        </button>
      </Tooltip>
    );
  }

  if (type == "allReports") {
    return (
      <Tooltip title="Todos los reportes" arrow>
        <button onClick={openModal} className={`${BASE_ICON_BTN} ${COLOR.accent}`}>
          <FaChartBar size={18} />
        </button>
      </Tooltip>
    );
  }

  if (type == "meeting") {
    return (
      <Tooltip title="Reunion" arrow>
        <button onClick={openModal} className={`${BASE_ICON_BTN} ${COLOR.primary}`}>
          <FaCalendarAlt size={18} />
        </button>
      </Tooltip>
    );
  }

  if (type == "AllMeeting") {
    return (
      <Tooltip title="Lista de Reuniones" arrow>
        <button onClick={openModal} className={`${BASE_ICON_BTN} ${COLOR.secondary}`}>
          <FaRegListAlt size={18} />
        </button>
      </Tooltip>
    );
  }

  if (type == "addPerso") {
    return (
      <Tooltip title="Bimestre" arrow>
        <button
          onClick={openModal}
          className={`${BASE_LABEL_BTN} ${disabled && disabled === "Todos" ? COLOR.disabled : COLOR.secondary}`}
        >
          <FaList size={17} />
        </button>
      </Tooltip>
    );
  }

  if (type == "editPersonalizado") {
    return (
      <Tooltip title="Editar" arrow>
        <button
          onClick={openModal}
          className={`w-full border ${COLOR.primary} text-white font-semibold py-2 px-4 rounded flex items-center justify-center gap-3`}
        >
          <FaRegEdit size={18} />
          Editar
        </button>
      </Tooltip>
    );
  }

  if (type == "validateInfo") {
    return (
      <Tooltip title="Validar Informacio" arrow>
        <button onClick={openModal} className={`${BASE_ICON_BTN} ${COLOR.secondary}`}>
          <GrValidate size={18} />
        </button>
      </Tooltip>
    );
  }

  if (type == "pago") {
    return (
      <Tooltip title="Pago" arrow>
        <button onClick={openModal} className={`${BASE_ICON_BTN} ${COLOR.secondary}`}>
          <FaMoneyBill1 size={18} />
        </button>
      </Tooltip>
    );
  }

  if (type == "pagoSuccess") {
    return (
      <Tooltip title="Pago" arrow>
        <button onClick={openModal} className={`${BASE_ICON_BTN} ${COLOR.success}`}>
          <FaMoneyBill1 size={18} />
        </button>
      </Tooltip>
    );
  }

  if (type == "changeSection") {
    return (
      <Tooltip title="Cambio de seccion" arrow>
        <button onClick={openModal} className={`${BASE_ICON_BTN} ${COLOR.success}`}>
          <FaExchangeAlt size={18} />
        </button>
      </Tooltip>
    );
  }

  if (type == "verify") {
    return (
      <button
        onClick={openModal}
        disabled={disabled == "Todos" ? true : false}
        className={`${BASE_LABEL_BTN} ${disabled && disabled === "Todos" ? COLOR.disabled : COLOR.success}`}
      >
        <RiVerifiedBadgeLine size={20} /> Verificar Matriculas
      </button>
    );
  }

  if (type == "transfer") {
    return (
      <Tooltip title="Translado" arrow>
        <button onClick={openModal} className={`${BASE_ICON_BTN} ${COLOR.secondary}`}>
          <FaSchool size={20} />
        </button>
      </Tooltip>
    );
  }

  if (type == "discount") {
    return (
      <Tooltip title="Descuento" arrow>
        <button onClick={openModal} className={`${BASE_ICON_BTN} ${COLOR.secondary}`}>
          <CiDiscount1 size={20} />
        </button>
      </Tooltip>
    );
  }

  if (type == "list") {
    return (
      <Tooltip title="Lista" arrow>
        <button
          disabled={disabled === "grade" ? true : false}
          onClick={openModal}
          className={`${BASE_ICON_BTN} ${disabled && disabled === "grade" ? COLOR.disabled : COLOR.secondary}`}
        >
          <CiBoxList size={20} />
        </button>
      </Tooltip>
    );
  }

  if (type == "addCouse") {
    return (
      <Tooltip title="Agregar Curso" arrow>
        <button onClick={openModal} className={`${BASE_ICON_BTN} ${COLOR.secondary}`}>
          <MdAddBox size={20} />
        </button>
      </Tooltip>
    );
  }

  if (type == "competency") {
    return (
      <Tooltip title="Agregar Competencia" arrow>
        <button onClick={openModal} className={`${BASE_ICON_BTN} ${COLOR.secondary}`}>
          <CgAdd size={20} />
        </button>
      </Tooltip>
    );
  }

  if (type == "assign") {
    return (
      <Tooltip title="Agregar Asignacion" arrow>
        <button onClick={openModal} className={`${BASE_ICON_BTN} ${COLOR.secondary}`}>
          <CgAdd size={20} />
        </button>
      </Tooltip>
    );
  }

  if (type === "file") {
    return (
      <Tooltip title="Subir Archivo" arrow>
        <button onClick={openModal} className={`${BASE_ICON_BTN} ${COLOR.secondary}`}>
          <FaUpload size={20} />
        </button>
      </Tooltip>
    );
  }

  if (type == "details") {
    return (
      <Tooltip title="Descuento" arrow>
        <button onClick={openModal} className={`${BASE_ICON_BTN} ${COLOR.secondary}`}>
          <FaInfoCircle size={20} />
        </button>
      </Tooltip>
    );
  }

  if (type == "debtGenerator") {
    return (
      <Tooltip title="Generar Deudas" arrow>
        <button onClick={openModal} className={`${BASE_ICON_BTN} ${COLOR.primary}`}>
          <MdAttachMoney size={20} />
        </button>
      </Tooltip>
    );
  }

  if (type == "generateDebt") {
    return (
      <button
        onClick={openModal}
        className={`${BASE_LABEL_BTN} px-4 py-2 ${COLOR.success}`}
      >
        <MdAttachMoney size={20} />
        Generar deuda
      </button>
    );
  }

  if (type == "cancelDebts") {
    return (
      <Tooltip title="Cancelar Deuda" arrow>
        <button onClick={openModal} className={`${BASE_ICON_BTN} ${COLOR.secondary}`}>
          <FaHandHoldingUsd size={18} />
        </button>
      </Tooltip>
    );
  }

  if (type == "rols") {
    return (
      <Tooltip title="Roles" arrow>
        <button onClick={openModal} className={`${BASE_ICON_BTN} ${COLOR.secondary}`}>
          <FaUserShield size={18} />
        </button>
      </Tooltip>
    );
  }
};
